import dayjs from "dayjs";
import { VOUCHERS } from "../shared/tagTypes";
import { baseApi } from "./base";

const voucherApi = baseApi
    .enhanceEndpoints({
        addTagTypes: [VOUCHERS],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getNewVoucherNo: builder.query({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/vouchers/${payload.voucherTypeId}/voucher-no`,
                    params: {
                        date: payload.voucherDate
                    },
                }),
                providesTags: [VOUCHERS],
            }),
            getVoucher: builder.query({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/vouchers/${payload.id}`,
                    params: {
                        withDetail: payload.withDetail
                    }
                }),
                providesTags: [VOUCHERS],
            }),
            searchVouchers: builder.mutation({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/vouchers/search`,
                    method: "POST",
                    body: payload.body,
                })
            }),
            createVoucher: builder.mutation({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/vouchers`,
                    method: "POST",
                    body: payload.body,
                }),
                invalidatesTags: [VOUCHERS],
            }),
            updateVoucher: builder.mutation({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/vouchers/${payload.id}`,
                    method: "PUT",
                    body: payload.body,
                }),
                invalidatesTags: [VOUCHERS],
            }),
            deleteVoucher: builder.mutation({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/vouchers/${payload.id}`,
                    method: "DELETE",
                }),
                invalidatesTags: [VOUCHERS],
            }),
            checkVoucher: builder.mutation({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/vouchers/${payload.id}/check`,
                    method: "PATCH",
                    body: payload.body,
                }),
                invalidatesTags: [VOUCHERS],
            }),
            approveVoucher: builder.mutation({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/vouchers/${payload.id}/approve`,
                    method: "PATCH",
                    body: payload.body,
                }),
                invalidatesTags: [VOUCHERS],
            }),
            commentOnVoucher: builder.mutation({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/vouchers/${payload.id}/comment`,
                    method: "POST",
                    body: payload.body,
                }),
                invalidatesTags: [VOUCHERS],
            })
        }),

        overrideExisting: false,
    });

export const {
    useGetNewVoucherNoQuery,
    useLazyGetNewVoucherNoQuery,
    useGetVoucherQuery,
    useLazyGetVoucherQuery,
    useSearchVouchersMutation,
    useCreateVoucherMutation,
    useUpdateVoucherMutation,
    useDeleteVoucherMutation,
    useCheckVoucherMutation,
    useApproveVoucherMutation,
    useCommentOnVoucherMutation
} = voucherApi;
